enum ENTITY_TYPE {
  GIFT = "GIFT",
  PARTICIPANT = "PARTICIPANT",
  PLAYLIST = "PLAYLIST",
  PROJECT = "PROJECT",
  QUESTION = "QUESTION",
  SCRIPT = "SCRIPT",
  USER = "USER",
  VIDEO = "VIDEO",
  CLIP = "CLIP",
}

export default ENTITY_TYPE;
